export const formatPrice = (price) => {
  return new Intl.NumberFormat("hu-HU").format(price) + " Ft";
};

export const formatKm = (km) => {
  return new Intl.NumberFormat("hu-HU").format(km) + " km";
};

export const FUEL_TYPES = ["Benzin", "Dízel", "Elektromos", "Hibrid", "Plug-in hibrid", "Gáz"];
export const TRANSMISSIONS = ["Manuális", "Automata"];
export const BODY_TYPES = ["Ferdehátú", "Limuzin", "Kombi", "SUV", "Terepjáró", "Kupé", "Kabrió", "Egyterű", "Pickup"];
export const COLORS = [
  "Fehér", "Fekete", "Ezüst", "Szürke", "Antracit", "Piros", "Bordó",
  "Kék", "Sötétkék", "Zöld", "Sárga", "Narancs", "Barna", "Bézs", "Arany",
];
